
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    private _authenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public isAuthenticated$: Observable<boolean> = this._authenticated.asObservable();

    private _userProfile: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
    public userProfile$ = this._userProfile.asObservable();

    constructor(private oidcSecurityService: OidcSecurityService) {
        this.oidcSecurityService.isAuthenticated$.subscribe(isAuthenticated => this._authenticated.next(isAuthenticated));
        this.oidcSecurityService.userData$.subscribe(userData => this._userProfile.next(userData));
    }

    login(): void {

        this.oidcSecurityService.authorize();
    }

    logout(): void {
        this.oidcSecurityService.logoff();
    }

    getAccessToken(): string {
        return this.oidcSecurityService.getToken();
    }

    getUserProfile(): any {
        return this._userProfile.getValue();
    }

    forceReload(): void {
        this.oidcSecurityService.forceRefreshSession().toPromise().then(() => console.warn('session force reloaded'));
    }
}
